<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M7.11 29h17.78a2 2 0 001.48-.66 2 2 0 00.51-1.55l-1.73-16a2 2 0 00-2-1.79H21V8a5 5 0 00-10 0v1H8.83a2 2 0 00-2 1.79l-1.73 16a2 2 0 00.51 1.55 2 2 0 001.5.66zM13 8a3 3 0 016 0v1h-6zm-4.17 3H11v1a1 1 0 002 0v-1h6v1a1 1 0 002 0v-1h2.17l1.72 16H7.11z"/></svg>